import { ReactElement, useEffect, useRef } from 'react';
import { AnimationContainer, BadgeBackground, BadgeContainer } from './Badge.styled';
import { StageColors } from '@models/BadgeColors';
import Lottie from 'react-lottie-player';

interface IProps {
  enabled?: boolean;
  stage: number;
  stages?: number;
  preview?: boolean;
  reward?: boolean;
  badge?: any;
  lottie?: any;
}

const Badge = (props: IProps) => {

  return (
    <BadgeContainer hideBadge={props.preview} earned={props.enabled}>
      {props.reward ? <props.badge.badgeImage /> : <AnimationContainer><Lottie {...props?.lottie} play style={{width:'100%',height:'100%',overflow:'hidden',margin:'0 auto'}} /></AnimationContainer>}

      <BadgeBackground reward={props.reward} colors={props.stages ? StageColors[props.stages > StageColors.length - 1?StageColors.length - 1:props.stages] : StageColors[props.stage > StageColors.length?StageColors.length-1:props.stage]}></BadgeBackground>
    </BadgeContainer>
  );
};

export default Badge;
